import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import MapPoint from 'components/maps/MapPoint';
import AzureMapBase from 'components/maps/azure/AzureMapBase';
import AzureMapMarker from 'components/maps/azure/AzureMapMarker';

const MapPointManager = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || panel?.map_provider || 'lf';

    switch (provider) {
        case 'azure':
        case 'az': {
            const {center, zoom = 14, height = '300px', azureMapsKey} = props;
            return (
                <AzureMapBase center={center} zoom={zoom} height={height} subscriptionKey={azureMapsKey}>
                    <AzureMapMarker
                        position={center}
                        popup={`Coordenadas: ${center[0]}, ${center[1]}`}
                    />
                </AzureMapBase>
            );
        }
        case 'lf':
        default:
            return <MapPoint {...props} />;
    }
};

export default MapPointManager;
